var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLockedStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M16.6666667,9.33333333 L15.9047619,9.33333333 L15.9047619,7.80952381 C15.9047619,5.70666667 14.1980952,4 12.0952381,4 C9.99238095,4 8.28571429,5.70666667 8.28571429,7.80952381 L8.28571429,9.33333333 L7.52380952,9.33333333 C6.68571429,9.33333333 6,10.0190476 6,10.8571429 L6,18.4761905 C6,19.3142857 6.68571429,20 7.52380952,20 L16.6666667,20 C17.5047619,20 18.1904762,19.3142857 18.1904762,18.4761905 L18.1904762,10.8571429 C18.1904762,10.0190476 17.5047619,9.33333333 16.6666667,9.33333333 Z M9.80952381,7.80952381 C9.80952381,6.5447619 10.8304762,5.52380952 12.0952381,5.52380952 C13.36,5.52380952 14.3809524,6.5447619 14.3809524,7.80952381 L14.3809524,9.33333333 L9.80952381,9.33333333 L9.80952381,7.80952381 Z M16.6666667,18.4761905 L7.52380952,18.4761905 L7.52380952,10.8571429 L16.6666667,10.8571429 L16.6666667,18.4761905 Z M12.0952381,16.1904762 C12.9333333,16.1904762 13.6190476,15.5047619 13.6190476,14.6666667 C13.6190476,13.8285714 12.9333333,13.1428571 12.0952381,13.1428571 C11.2571429,13.1428571 10.5714286,13.8285714 10.5714286,14.6666667 C10.5714286,15.5047619 11.2571429,16.1904762 12.0952381,16.1904762 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#C60000",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLockedStatus);
export default __webpack_public_path__ + "static/media/icon_locked_status.0e1d860d981446791fa0afbd7e5d69ae.svg";
export { ForwardRef as ReactComponent };